import React from "react";
import { IMobileCtaProps } from "./MobileCtaProps";
import { MobileCtaBanner, Title } from "./MobileCtaHelpers";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import GoogleIcon from "../../../images/google-play-badge.png";

const MobileCta: React.FC<IMobileCtaProps> = (props) => {
  const node = props.node;
  const bannerImage = node.relationships?.desktopImage
    ? node.relationships.desktopImage.relationships.field_media_image
        .gatsbyImage
    : null;
  const mobileImage = node.relationships
    ? node.relationships.mobileImage.relationships.field_media_image.gatsbyImage
    : null;
  const icon = node.relationships.field_icon
    ? node.relationships.field_icon.relationships.field_media_file.gatsbyImage
    : null;
  const iconGatsbyImage = node.relationships.field_icon
    ? getImage(
        node.relationships.field_icon.relationships.field_media_file
          .gatsbyImage as any
      )
    : null;
  let currentImage;
  if (typeof window !== "undefined" && window.innerWidth < 992) {
    currentImage = mobileImage;
  } else {
    currentImage = bannerImage;
  }
  return (
    <MobileCtaBanner {...props}>
      <div className={`column text-center left-panel`}>
        {icon && icon.gatsbyImage && (
          <GatsbyImage
            className={`icon`}
            image={iconGatsbyImage}
            alt={
              node.relationships.field_media
                ? node.relationships.field_media.field_media_image?.alt
                : "Hello Rewards Mobile App"
            }
          ></GatsbyImage>
        )}
        {icon && !icon.childImageSharp && (
          <img
            className={`icon`}
            src={icon?.publicUrl}
            alt={
              node.relationships.field_media
                ? node.relationships.field_media.field_media_image?.alt
                : "Hello Rewards Mobile App"
            }
          ></img>
        )}
      </div>
      <div className={`column text-center right-panel`}>
        <Title>{node.field_title}</Title>
        <p
          className="description"
          dangerouslySetInnerHTML={{
            __html: node.field_description_formatted.value,
          }}
        ></p>
        <Link to={node.field_apple_app_link.url}>
          <svg className="appleIcon">
            <use xlinkHref="/svg/apple-store-icon.svg#AppleIcon"> </use>
          </svg>
        </Link>
        <Link to={node.field_google_app_link.url}>
          <img
            className="googleIcon"
            src={GoogleIcon}
            alt={node.field_google_app_link.title}
          />
        </Link>
      </div>
    </MobileCtaBanner>
  );
};

export default MobileCta;
